import { render } from "./ConfiguracionComponent.vue?vue&type=template&id=2aa45bd4&scoped=true"
import script from "./ConfiguracionComponent.vue?vue&type=script&lang=js"
export * from "./ConfiguracionComponent.vue?vue&type=script&lang=js"

import "./ConfiguracionComponent.vue?vue&type=style&index=0&id=2aa45bd4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dvdsa\\projects\\avante-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa45bd4"]])

export default __exports__